var $ts = jQuery.noConflict();
var th_site_url = Shopify.shop;
if(typeof th_site_url != 'undefined' && th_site_url != '' && th_site_url != null){
  var th_site_new_url = th_site_url.replace(/^https?\:\/\//i, '');
}
var th_money_format = $ts('#th_money_format').attr('content');
var th_search_input = 'input[name="q"],.th-sf-form input[type="text"]';
function getsearch_result(resultsList, search_term) {
  var th_input_vel = '*' + search_term + '*'; 
  jQuery.getJSON("/search/suggest.json", {
    "q": th_input_vel,
    "resources": {
      "type": "product,page,article,collection",
      "limit": 10,
      "options": {
        "unavailable_products": "last"            
      }
    }
  }).done(function(response) {    
    var th_results_products = response.resources.results.products;
    var th_results_collections = response.resources.results.collections;
    var th_results_pages = response.resources.results.pages;
    var th_results_articles = response.resources.results.articles;           
    if (th_results_products.length == 0 && th_results_collections.length == 0 && th_results_pages.length == 0 && th_results_articles.length == 0) {        
      resultsList.html('<div class="th_in_note">Sorry, nothing found for "<span>' + search_term + '</span>"</div>');
    } else {
      resultsList.empty();
      var th_pro_list_post = '',th_SuggestionsList = '',th_CollectionsList = '',th_PagesList = '',th_ArticleslList = '',th_in_boxs_item = '';
      th_in_boxs_item += '<div class="th_in_topbar"><ul class="th_in_tabs">';
      th_in_boxs_item += '<li class="th_in_tb_items th_in_active"><button type="button" data-toggle="th_in_suggestions" class="th_in_item_link">See all results <span class="th_in_item_total">(' + th_results_products.length + ')</span></button></li>';
      if (th_results_collections.length != 0) {
        th_in_boxs_item += '<li class="th_in_tb_items"><button type="button" data-toggle="th_in_collections" class="th_in_item_link">Collections<span class="th_in_item_total">(' + th_results_collections.length + ')</span></button></li>';
      }
      if (th_results_pages.length != 0 || th_results_articles.length != 0) {
        var th_page_artical_count = th_results_pages.length + th_results_articles.length;
        th_in_boxs_item += '<li class="th_in_tb_items"><button type="button" data-toggle="th_in_pages-blogs" class="th_in_item_link">Pages / Blogs<span class="th_in_item_total">(' + th_page_artical_count + ')</span></button></li>';
      }
      th_in_boxs_item += '</ul></div>';
      th_in_boxs_item += '<div class="th_in_tab_content">';
      th_in_boxs_item += '<div class="th_in_tab_panel th_in_suggestions th_in_active">';
      th_in_boxs_item += '<div class="th_in_panel_content">';            

      th_in_boxs_item += '<h5 class="th_in_label">Product</h5>';
      th_in_boxs_item += '<div class="th_in_product_wrapp">';
      th_in_boxs_item += '<div class="th_in_pw_scrollbar"><ul class="th_in_product_intro th_in_grid_view th_in_gridcount_3"></ul></div>';
      th_in_boxs_item += '<div class="th_in_bottom_btn"><button type="button" class="th_in_view_all_link">View all items</button></div>';
      th_in_boxs_item += '</div>';
      th_in_boxs_item += '</div>';
      th_in_boxs_item += '</div>';
      if (th_results_collections.length != 0) {
        th_in_boxs_item += '<div class="th_in_tab_panel th_in_collections"><div class="th_in_panel_content">';
        th_in_boxs_item += '<div class="th_in_panel_content">';
        th_in_boxs_item += '<h5 class="th_in_label">Categories</h5>';
        th_in_boxs_item += '<ul class="th_in_navlist th_in_collection_results_list">';
        th_in_boxs_item += '</div>';
        th_in_boxs_item += '</div></div>';
      }
      if (th_results_pages.length != 0 || th_results_articles.length != 0) {
        th_in_boxs_item += '<div class="th_in_tab_panel th_in_pages-blogs"><div class="th_in_panel_content">';
        th_in_boxs_item += '<div class="th_in_panel_content">';
        th_in_boxs_item += '<ul class="th-sf-col-grid-wrap">';
        if (th_results_pages.length != 0) {
          th_in_boxs_item += '<li class="th-sf-col-item th-sf-col-2">';
          th_in_boxs_item += '<h5 class="th_in_label">Pages</h5>';
          th_in_boxs_item += '<ul class="th_in_navlist th_in_page_results_list"></ul>';
          th_in_boxs_item += '</li>';
        }
        if (th_results_articles.length != 0) {
          th_in_boxs_item += '<li class="th-sf-col-item th-sf-col-2">';
          th_in_boxs_item += '<h5 class="th_in_label">Blogs</h5>';
          th_in_boxs_item += '<ul class="th_in_navlist th_in_article_results_list"></ul>';
          th_in_boxs_item += '</li>';
        }
        th_in_boxs_item += '</ul>';
        th_in_boxs_item += '<div class="</div>';
        th_in_boxs_item += '</div></div>';
      }
      th_in_boxs_item += '</div>';
      resultsList.html(th_in_boxs_item);
      th_pro_list_post += th_pro_searct_list(th_results_products,th_results_products.length,);
                                             resultsList.find('.th_in_product_intro').html(th_pro_list_post);
      if (th_results_collections.length != 0) {
        th_CollectionsList += th_in_collection_list(th_results_collections,th_results_collections.length);
        resultsList.find('.th_in_collection_results_list').html(th_CollectionsList);
      }

      if (th_results_pages.length != 0) {
        th_PagesList += th_in_pages_list(th_results_pages,th_results_pages.length);
        resultsList.find('.th_in_page_results_list').html(th_PagesList);
      }

      if (th_results_articles.length != 0 ) {
        th_ArticleslList += th_in_articles_list(th_results_articles,th_results_articles.length);
        resultsList.find('.th_in_article_results_list').html(th_ArticleslList);
      }
    }
  });

}
function th_pro_searct_list(product_search_item,count) {

  var th_search_item = '';
  $.each(product_search_item, function(index, item) {
    function stripHtml(html){
    // Create a new div element
    var temporalDivElement = document.createElement("div");
    // Set the HTML content with the providen
    temporalDivElement.innerHTML = html;
    // Retrieve the text property of the element (cross-browser support)
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
}

var htmlString= item.body;
 var myStr = stripHtml(htmlString)

//Hello World
//It's me, Mario

     var maxLength = 110;
     var newStr = myStr.substring(0, maxLength);

    if(item.image != null){
      var img = item.image 
      }else{
      var img = '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_300x.gif'
      }
    
    th_search_item += '<li class="th_in_pi_item"><a href="'+ item.url +'" >';
    th_search_item += '<div class="th_in_product_item">';
    th_search_item += '<figure class="th_in_pi_thumb"><img src="' + img + '" alt="' + item.title + '"></figure>';
    th_search_item += '<div class="th_in_pi_details">';
    th_search_item += '<div class="th_in_meta">' + item.vendor + '</div>';
    th_search_item += '<h3 class="th_in_pi_title">' + item.title + '</h3>';
    th_search_item += '<p>' + newStr + '....</p>';
    th_search_item += '<div class="th_in_pi_price">';
    th_search_item += '<span class="th_in_sale_price money">' + Shopify.formatMoney(item.price, th_money_format) + '</span>';
    if (item.compare_at_price_max != '0.00'  ) {
      th_search_item += '<span class="th_in_compare_price money">' + Shopify.formatMoney(item.compare_at_price_max, th_money_format) + '</span>';
    }
    th_search_item += '</div>';
    th_search_item += '</div>';
    th_search_item += '</div>';
    th_search_item += '</a></li>';
    if ( index === 9 - 1 ) {
      return false; 
    }
  });  
  return th_search_item;
}






function th_in_collection_list(collections_search_item) {
  var th_search_coll_item = '';
  $.each(collections_search_item, function(index, item) {
    th_search_coll_item += ' <li class="th_in_nl_item"><a href="/collections/' + item.handle + '">' + item.title + '</a></li>';    
  });
  return th_search_coll_item;
}
function th_in_pages_list(pages_search_item) {
  var th_search_page_item = '';
  $.each(pages_search_item, function(index, item) {
    th_search_page_item += ' <li class="th_in_nl_item"><a href="/pages/' + item.handle + '">' + item.title + '</a></li>';    
  });
  return th_search_page_item;
}
function th_in_articles_list(articles_search_item) {
  var th_search_page_item = '';
  $ts.each(articles_search_item, function(index, item) {
    th_search_page_item += ' <li class="th_in_nl_item"><a href="/blogs/'+item.blog_handle+'/'+item.handle+'">' + item.title + '</a></li>';    
  });
  return th_search_page_item;
}
$ts(document).ready(function() {
  $ts('body').click(function(e) {
    var container = $ts(th_search_input).parents('form');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $ts('.th_in_results_content').hide();
    }
  });
  $ts(th_search_input).parents('form').append('<div class="th_in_results_content"></div>');
  var timer; 
  $ts(th_search_input).attr('autocomplete', 'off').bind('focus keyup', function(e) {     

    if ($ts(this).val().length == 0) {
      $ts('.th_in_results_content').hide();
    } else {
      $ts('.th_in_results_content').show();
    }   

    clearTimeout(timer);
    timer = setTimeout(function() {
      var th_form = $ts(this).closest('form');
      var th_input_vel = $ts(this).val();

      var resultsList = $ts('.th_in_results_content');
      var linkURL = th_form.attr('action') + '?type=product&q=' + th_input_vel;
      $ts('.th_in_results_content').html('<div class="load"></div>');
      getsearch_result(resultsList, th_input_vel);
    }.bind(this), 555);  



    $ts('.search-form, #search-form').on('submit', function(e) {
      e.preventDefault();
      var th_input_vel = $ts(this).find('input[name="q"]').val();
      var linkURL = $ts(this).attr('action') + '?type=product&q=' + th_input_vel;
      window.location = linkURL;
    });   
  });
});
$ts(document).on("click", "li.th_in_tb_items button.th_in_item_link", function() {
  event.preventDefault();
  var th_active_dt = $ts(this).attr('data-toggle');  
  $ts('ul.th_in_tabs li.th_in_tb_items').removeClass('th_in_active');
  $ts(this).parent('li.th_in_tb_items').addClass('th_in_active');
  $ts('.th_in_tab_content div.th_in_tab_panel').removeClass('th_in_active');
  $ts("."+th_active_dt).addClass('th_in_active');
});
var $ = jQuery.noConflict();